export const METERS_PER_KILOMETER = 1000;
export const METERS_PER_FOOT = 0.3048;
export const METERS_PER_MILE = 1609.344;

/**
 * Meters in one large site distance unit (mile for imperial sites, kilometer otherwise).
 * Every meters <-> MI/KM conversion should go through here so displayed and edited values never drift apart
 */
export function getMetersPerLargeDistanceUnit(isImperial: boolean): number {
  return isImperial ? METERS_PER_MILE : METERS_PER_KILOMETER;
}
